import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { ApiHelperV2 } from '../helpers/ApiHelperV2';
import { Helper } from '../helpers/Helper';
import { Controller } from '../Controller';
import { AppTheme } from '../../styles/AppTheme';

export class DialogMsg extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <Dialog
        onClose={this.props.dialogClose}
        open={this.props.eventDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <div className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{this.props.title}</p>
          <div className={css(Styles.dialogCloseButton)}>
            <Icon className={css(Styles.closeIcon)} color='secondary' onClick={this.props.dialogClose}>
              cancel
            </Icon>
          </div>
        </div>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.eventDetailContent)}>
            <p className={css(Styles.eventListDate)}>{this.props.desc}</p>
          </div>
        </DialogContent>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialog: {
    width: 500,
  },
  dialogTitle: {
    padding: 10,
    backgroundColor: AppTheme.secondaryBg,
    display: 'flex'
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 23,
    margin: 0,
    color: 'black'
  },
  dialogCloseButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'center'
  },
  closeIcon: {
    color: 'black',
    cursor: 'pointer'
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden'
  },
  eventDetailContent: {
    padding: '20px 10px 30px 10px',
    display: 'flex'
  },
  eventListDate: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600
  },

})



// WEBPACK FOOTER //
// ./src/common/components/DialogMsg.js